import { useEffect, useRef, useState } from 'react';
import ourStoreImage from '../../../assets/website/images/our-story-image.png';
import { GetCMSDetails } from '../services/cms.services';
import { Placeholder } from 'rsuite';
import { useSelector } from 'react-redux';

export default function OutStorySection() {
  const descriptionRef = useRef();
  const [pageData, setPageData] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [getGlobalData, setGlobalData] = useState({});
  useEffect(() => {
    setDataLoaded(false);
    GetCMSDetails("our-story").then((response) => {
      if (response.success) {
        setPageData(response.data)
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setDataLoaded(true);
    });
  }, []);

  const myGlobalData = useSelector((state) => state.globalData);

  useEffect(() => {
    if (myGlobalData && myGlobalData?.data) {
      const settingsData = JSON.parse(myGlobalData?.data);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  function handleReadMore(e) {
    e.preventDefault();
    if (e.target.innerText === "Read more") {
      e.target.innerText = "Read less";
      descriptionRef.current.classList.add('active');
    } else {
      e.target.innerText = "Read more";
      descriptionRef.current.classList.remove('active');
    }
  }

  return (
    <section className="our-story section-padding">
      <div className="container-fluid">
        <div className="container-box">
          <div className="row row-gap-4">
            <div className="col-md-6">
              {
                dataLoaded ?
                  <div className="story-box "> 
                    <span className="subheading">{pageData?.title}</span>
                    {/* <h2 className="h2-headline">{pageData?.title}</h2> */} 
                     <h2 className="h2 ink">every appointment. <br/> every match. every <br/> pro. <span className="ed_los_alamos"> one place.</span></h2>
                    {pageData?.description ? <div className='body-1 read-more-container pb-0 mb-3' ref={descriptionRef} dangerouslySetInnerHTML={{ __html: pageData?.description }}></div> : null}
                    {/* {pageData?.description?.length > 300 ? <button className="btn btn-purple mt-4 activated" onClick={handleReadMore}>Read more</button> : null} */}
                    <div className="store-badges">
                      <a
                        href={getGlobalData?.app_store_url || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn_2 decoration-none"
                      >
                        <span>COMING SOON</span>
                        <span>App Store</span>
                      </a>
                      <a
                        href={getGlobalData?.play_store_url || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn_2 decoration-none"
                      >
                        <span>COMING SOON</span>
                        <span>Google Play</span>
                      </a>
                    </div>
                  </div>
                  :
                  <div className='w-100 website-placeholder '>
                    <Placeholder.Paragraph ac={{ backgroundColor: "red" }} className='mb-3' rowHeight={60} active rows={1} />
                    <Placeholder.Paragraph ac={{ backgroundColor: "red" }} rowHeight={25} active rows={5} />
                  </div>
              }
            </div>
            <div className="col-md-6">
              <figure className="">
                <video src={getGlobalData?.brand_video_url} controls className='video-box' autoplay="" name="media" class="video-box"></video>
                {/* <img src={ourStoreImage} alt="our-story-image" /> */}
                {/* <iframe  className='video-box' frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Vimeo Video"></iframe> */}
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
